import { Directive, Input, Output, HostBinding, HostListener, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';
var SuiTab = (function () {
    function SuiTab() {
        var _this = this;
        this._isActive = false;
        this._isDisabled = false;
        this.isActiveChange = new EventEmitter(false);
        this.onActivate = new EventEmitter(false);
        this.stateChanged$ = new Observable(function (observer) {
            _this._stateObserver = observer;
            _this._stateObserver.next(_this);
        });
    }
    Object.defineProperty(SuiTab.prototype, "suiTabHeader", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (!this.id) {
                this.id = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiTab.prototype, "content", {
        /**
         * @return {?}
         */
        get: function () { return this._content; },
        /**
         * @param {?} content
         * @return {?}
         */
        set: function (content) {
            this._content = content;
            content.isActive = this.isActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiTab.prototype, "isActive", {
        /**
         * @return {?}
         */
        get: function () { return this._isActive; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var /** @type {?} */ change = this._isActive != value;
            this._isActive = value;
            if (this._content) {
                this._content.isActive = value;
            }
            this.stateObserverNext(change);
            this.isActiveChange.emit(this._isActive);
            if (value && change) {
                this.onActivate.emit(this);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiTab.prototype, "isDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this._isDisabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var /** @type {?} */ change = this._isDisabled != value;
            this._isDisabled = value;
            this.stateObserverNext(change);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} change
     * @return {?}
     */
    SuiTab.prototype.stateObserverNext = function (change) {
        if (change && this._stateObserver) {
            this._stateObserver.next(this);
        }
    };
    Object.defineProperty(SuiTab.prototype, "manuallyActivate", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var _this = this;
            setTimeout(function () {
                _this.isActive = _this.isDisabled ? false : value;
                _this.isActiveChange.emit(_this._isActive);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SuiTab.prototype, "manuallyDisable", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var _this = this;
            setTimeout(function () {
                _this.isDisabled = value;
            });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SuiTab.prototype.click = function () {
        if (!this.isDisabled) {
            this.isActive = true;
        }
    };
    return SuiTab;
}());
export { SuiTab };
SuiTab.decorators = [
    { type: Directive, args: [{
                selector: '[suiTabHeader]'
            },] },
];
/**
 * @nocollapse
 */
SuiTab.ctorParameters = function () { return []; };
SuiTab.propDecorators = {
    'suiTabHeader': [{ type: Input },],
    'isActive': [{ type: HostBinding, args: ['class.active',] },],
    'isDisabled': [{ type: HostBinding, args: ['class.disabled',] },],
    'manuallyActivate': [{ type: Input, args: ['isActive',] },],
    'manuallyDisable': [{ type: Input, args: ['isDisabled',] },],
    'isActiveChange': [{ type: Output },],
    'onActivate': [{ type: Output },],
    'click': [{ type: HostListener, args: ['click',] },],
};
function SuiTab_tsickle_Closure_declarations() {
    /** @type {?} */
    SuiTab.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    SuiTab.ctorParameters;
    /** @type {?} */
    SuiTab.propDecorators;
    /** @type {?} */
    SuiTab.prototype.id;
    /** @type {?} */
    SuiTab.prototype.index;
    /** @type {?} */
    SuiTab.prototype._content;
    /** @type {?} */
    SuiTab.prototype.stateChanged$;
    /** @type {?} */
    SuiTab.prototype._stateObserver;
    /** @type {?} */
    SuiTab.prototype._isActive;
    /** @type {?} */
    SuiTab.prototype._isDisabled;
    /** @type {?} */
    SuiTab.prototype.isActiveChange;
    /** @type {?} */
    SuiTab.prototype.onActivate;
}
//# sourceMappingURL=tab.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-semantic-ui/components/tabs/tab.js
// module id = ./node_modules/ng2-semantic-ui/components/tabs/tab.js
// module chunks = vendor